import React, { useState } from 'react';
import classes from './Documents.module.css';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import directoryIcon from '../../../assets/icons/directory.svg';
// import fileUploadIcon from '../../../assets/icons/file-upload.png';
import CustomTextField from '../../../components/UI/Inputs/CustomTextField';
import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import {
  fetchBase64,
  fetchDocuments,
  IDocument,
  selectDocuments,
  uploadDocument,
} from '../../../store/slices/documents';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import PreviewDocumentModal from '../../Consultations/Modals/PreviewDocumentModal';
import moment from 'moment';

import FileDropZone from '../../../components/UI/DropZone/DropZone';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  selectedSalesOrder: SalesOrderInfo;
};

const DiagnosticDocuments: React.FC<Props> = ({ selectedSalesOrder }) => {
  const dispatch = useAppDispatch();
  const documents: IDocument[] = useAppSelector<IDocument[]>(selectDocuments);
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);
  const [step, setStep] = React.useState<number>(0);
  const [selectedFile, setSelectedFile] = useState<File>();
  const [selectedDocument, setSelectedDocument] = React.useState<number | null>(null);
  const [documentFilename, setDocumentFilename] = useState<string>('');
  const [documentMimeType, setDocumentMimeType] = useState<string>('');
  const [documentTitle, setDocumentTitle] = useState<string>('');
  const [documentComments, setDocumentComments] = useState<string>('');
  const [viewOnly, setViewOnly] = useState<boolean>(false);
  const { translations } = useTranslation();

  const documentsDisplayed: IDocument[] = React.useMemo(() => {
    return documents ?? [];
  }, [documents]);

  React.useEffect(() => {
    dispatch(
      fetchDocuments({
        salesOrderId: selectedSalesOrder.sales_order.sales_order_id,
        salesOrderItemId: selectedSalesOrder.sales_order_item.sales_order_item_id,
      })
    );
  }, [dispatch, selectedSalesOrder]);

  const handleFileUpload = async () => {
    if (!selectedFile) return;
    try {
      const form = new FormData();
      form.append('filename_title', documentTitle);
      form.append('filename_description', documentComments);

      form.append('attachment', selectedFile ?? '');
      dispatch(
        uploadDocument({
          attachmentTypeId: 2,
          formData: form,
          salesOrderId: selectedSalesOrder.sales_order.sales_order_id,
          salesOrderItemId: selectedSalesOrder?.sales_order_item?.external_sales_order_item_id,
        })
      ).then(() => {
        setStep(0);
        setSelectedFile(undefined);
        setDocumentTitle('');
        setDocumentComments('');
      });
    } catch (_) {}
  };
  return (
    <div className={classes.container}>
      {step === 0 && (
        <div className={classes.documentList}>
          {documentsDisplayed?.map((doc, index) => {
            if (index === selectedDocument) {
              return (
                <div key={index} className={classes.editDocumentContainer}>
                  <div className={classes.documentInputFieldsContainer}>
                    <div className={classes.fields}>
                      <CustomTextField
                        label={translations('title').toString()}
                        value={'Test'}
                        onChange={() => {}}
                        maxWidth="300px"
                      />
                    </div>
                    <div className={classes.fields}>
                      <CustomTextField
                        label={translations('description').toString()}
                        value={'Test'}
                        onChange={() => {}}
                        maxWidth="300px"
                      />
                    </div>
                    <div className={classes.fields}>
                      <CustomTextField
                        label={translations('category').toString()}
                        value={'Test'}
                        onChange={() => {}}
                        maxWidth="300px"
                      />
                    </div>
                  </div>
                  <div className={classes.editDocumentContent}>
                    <div className={classes.documentDetails}>
                      <img className={classes.documentIcon} src={directoryIcon} alt={'directory'} />
                      <div className={classes.documentInfo}>
                        <div className={classes.documentPath}>
                          {doc.title && doc.title !== ''
                            ? `${doc.title}.${doc.mime_type}`
                            : doc.name}
                        </div>
                        <div className={classes.createdAt}>
                          {moment(doc.datetime_created).format('dd.mm.yyyy')}
                        </div>
                      </div>
                    </div>
                    <div
                      className={classes.editButton}
                      onClick={() => {
                        setSelectedDocument(index);
                      }}
                    >
                      {translations('remove')}
                    </div>
                    <PrimaryButtonV2
                      text={translations('add.document')}
                      invertedColors={true}
                      containerStyle={{
                        justifyContent: 'left',
                        marginTop: 5,
                        marginLeft: 20,
                      }}
                      buttonStyle={{
                        height: 31,
                        borderRadius: 4,
                        fontSize: 16,
                      }}
                      disabled={false}
                      onClick={() => setStep(1)}
                    />
                  </div>
                  <PrimaryButtonV2
                    text={translations('save')}
                    containerStyle={{
                      padding: '10px 0',
                      justifyContent: 'start',
                      marginTop: 30,
                    }}
                    buttonStyle={{
                      height: 32,
                      borderRadius: 4,
                      fontSize: 16,
                    }}
                    disabled={false}
                    onClick={() => {
                      setSelectedDocument(null);
                    }}
                  />
                </div>
              );
            } else {
              return (
                <div key={index} className={classes.documentListItem}>
                  <div className={classes.documentListItemSection}>
                    <div className={classes.documentListItemSectionLabel}>
                      {translations('title')}
                    </div>
                    <div>{doc.title ?? ''}</div>
                  </div>
                  <div className={classes.documentListItemSection}>
                    <div className={classes.documentListItemSectionLabel}>
                      {translations('description')}
                    </div>
                    <div>{doc.comment}</div>
                  </div>
                  {/* {doc.document_category_id && (
                    <div className={classes.documentListItemSection}>
                      <div className={classes.documentListItemSectionLabel}>
                        {translations('category')}
                      </div>
                      <div>{doc.document_category_id}</div>
                    </div>
                  )} */}
                  <div className={classes.documentListItemSection}>
                    <div className={classes.documentDetails}>
                      <img
                        className={classes.documentIcon}
                        onClick={() => {
                          setDocumentFilename(doc.name);
                          setDocumentMimeType('');
                          dispatch(fetchBase64(doc.name));
                          setViewOnly(true);
                        }}
                        src={directoryIcon}
                        alt={'directory'}
                      />
                      <div className={classes.documentInfo}>
                        <div
                          className={classes.documentPath}
                        >{`${doc.title}.${doc.mime_type}`}</div>
                        <div className={classes.createdAt}>
                          {moment(doc.datetime_created).format('DD.MM.yyyy')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={classes.documentListItemSection}>
                    <PrimaryButtonV2
                      invertedColors
                      text={translations('download')}
                      onClick={() => {
                        window.open(`${doc.attachment_url}`);
                      }}
                      containerStyle={{
                        marginRight: 10,
                      }}
                      buttonStyle={{
                        height: 50,
                      }}
                    />
                  </div>
                </div>
              );
            }
          })}
          <PrimaryButtonV2
            text={
              documentsDisplayed?.length > 0
                ? translations('add.document')
                : translations('add_document')
            }
            invertedColors={true}
            containerStyle={{
              justifyContent: 'left',
              marginTop: 30,
            }}
            buttonStyle={{
              height: 40,
              borderRadius: 4,
              fontSize: 16,
            }}
            disabled={false}
            onClick={() => setStep(1)}
          />
        </div>
      )}
      {step === 1 && (
        <div className={classes.addDocumentContainer}>
          <div className={classes.documentInputFieldsContainer}>
            <div className={classes.fields}>
              <CustomTextField
                label={translations('title').toString()}
                value={documentTitle}
                onChange={(event) => {
                  setDocumentTitle(event.target.value);
                }}
                maxWidth="300px"
              />
            </div>
            <div className={classes.fields}>
              <CustomTextField
                label={translations('description').toString()}
                value={documentComments}
                onChange={(event) => {
                  setDocumentComments(event.target.value);
                }}
                maxWidth="300px"
              />
            </div>
            {/*<div className={classes.fields}>*/}
            {/*  <CustomTextField*/}
            {/*    label="Category"*/}
            {/*    value={'Test'}*/}
            {/*    onChange={() => {}}*/}
            {/*    maxWidth="300px"*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
          <div>
            {selectedFile ? (
              <div className={classes.documentDetails}>
                <img
                  className={classes.documentIcon}
                  onClick={() => {
                    setDocumentFilename(selectedFile?.name);
                    setDocumentMimeType(selectedFile?.type);
                    setViewOnly(true);
                  }}
                  src={directoryIcon}
                  alt={'directory'}
                />
                <div className={classes.documentInfo}>
                  <div className={classes.documentPath}>{selectedFile?.name}</div>
                </div>
              </div>
            ) : (
              <FileDropZone onFilesDropped={setSelectedFile} />
            )}
          </div>
          <div className={classes.addDocumentButtons}>
            <PrimaryButtonV2
              text={translations('add_document')}
              containerStyle={{
                justifyContent: 'left',
                marginTop: 30,
              }}
              buttonStyle={{
                height: 40,
                borderRadius: 4,
                fontSize: 16,
              }}
              disabled={!selectedFile || documentTitle === '' || documentComments === ''}
              onClick={() => handleFileUpload()}
            />
            <PrimaryButtonV2
              text={translations('button.cancel')}
              invertedColors={true}
              containerStyle={{
                justifyContent: 'left',
                marginTop: 30,
                marginLeft: 20,
              }}
              buttonStyle={{
                height: 40,
                borderRadius: 4,
                fontSize: 16,
              }}
              disabled={false}
              onClick={() => setStep(0)}
            />
          </div>
          <input
            type={'file'}
            ref={hiddenFileInput}
            hidden
            accept=".pdf, .jpeg"
            onChange={(event) => {
              if (event.target.files) {
                setSelectedFile(event.target.files[0]);
              }
            }}
          />
        </div>
      )}
      {viewOnly && (
        <PreviewDocumentModal
          isOpen={viewOnly}
          onClose={() => setViewOnly(false)}
          documentFilename={documentFilename}
          documentMimeType={documentMimeType}
        />
      )}
      <PrimaryButtonV2
        text={translations('save')}
        containerStyle={{
          paddingTop: 20,
          justifyContent: 'start',
          marginTop: 'auto',
        }}
        buttonStyle={{
          height: 40,
          borderRadius: 4,
          fontSize: 16,
        }}
        disabled={false}
        onClick={() => {}}
      />
    </div>
  );
};

export { DiagnosticDocuments };
